import { render } from "./CreateChat.vue?vue&type=template&id=6e7d514a&scoped=true"
import script from "./CreateChat.vue?vue&type=script&lang=js"
export * from "./CreateChat.vue?vue&type=script&lang=js"

import "./CreateChat.vue?vue&type=style&index=0&id=6e7d514a&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7d514a"]])

export default __exports__